import { render } from "./TipPage.vue?vue&type=template&id=a68c9312"
import script from "./TipPage.vue?vue&type=script&lang=js"
export * from "./TipPage.vue?vue&type=script&lang=js"

import "./TipPage.vue?vue&type=style&index=0&id=a68c9312&lang=css"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__